<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5>Daftar Gadai</h5>
      </template>
      <div class="">
        <b-form-group label="Filter" label-for="filterInput" class="">
          <div class="d-flex search-input-wrapper">
            <b-form-input
              class="ml-2 mr-2"
              v-model="input.filterNoFaktur"
              name="filterNoFaktur"
              id="filterInput"
              type="search"
              placeholder="Masukkan no. faktur"
            ></b-form-input>
            <b-form-input
              class="mr-2"
              v-model="input.filterNamaAnggota"
              name="filterNamaAnggota"
              type="search"
              placeholder="Nama Anggota"
            ></b-form-input>
              <MultiSelectDropdown
                v-model="input.filterJenisBarang"
                :options="filterJenisBarang"
                text-field="name"
                value-field="id"
                placeholder="Pilih Jenis Barang"
              />
            
              <div class="daftar-gadai-filter-btn-wrapper">
                <b-button
                  class="mr-2"
                  variant="pgiBtn"
                  name="searchTableBtn"
                  :disabled="isBusy"
                  @click="onFilter()"
                >
                  <i class="fa fa-search"></i>
                </b-button>
                <b-button
                  variant="pgiBtn"
                  name="resetTableBtn"
                  :disabled="isBusy"
                  @click="onReset()"
                  >Reset</b-button
                >
              </div>
          </div>
        </b-form-group>
        <b-button
          class="mb-3"
          variant="pgiBtn"
          name="daftarBarangHilangBtn"
          @click="getDaftarBarangHilang"
          >Daftar Barang Hilang</b-button
        >
      </div>
      <b-table
        bordered
        hover
        show-empty
        :busy="isBusy"
        :items="daftarGadai"
        :fields="fields"
        :no-local-sorting="false"
        @sort-changed="sortingChanged"
        responsive
        class="mb-3"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Loading data...</strong>
          </div>
        </template>
        <template v-slot:empty> Tidak ada data gadai. </template>
        <template v-slot:cell(namaAnggota)="row">
          <p class="mb-0">{{ row.item.namaAnggota }}</p>
          <p class="mb-0 smallText text-muted">{{ row.item.noAnggota }}</p>
        </template>
        <template v-slot:cell(nilaiPinjamanEfektif)="row">
          <div class="text-right no-wrap">
            <p class="mb-0" v-if="row.item.pinjamanAwal !== null">
              Rp. {{ $helper.addThousandSeparator(row.item.pinjamanAwal) }}
            </p>
            <p class="mb-0" v-else>
              {{ $helper.addThousandSeparator(row.item.pinjamanAwal) }}
            </p>
          </div>
          <div class="text-right no-wrap smallText text-muted">
            <p class="mb-0" v-if="row.item.pinjamanEfektif !== null">
              Tersisa Rp. {{ $helper.addThousandSeparator(row.item.pinjamanEfektif) }}
            </p>
            <p class="mb-0" v-else>
              Tersisa {{ $helper.addThousandSeparator(row.item.pinjamanEfektif) }}
            </p>
          </div>
        </template>
        <template v-slot:cell(barang)="row">
          <div v-if="row.item.jenisPinjaman == 'Kendaraan'">
            <p class="mb-0">{{ row.item.jenis }}</p>
            <p class="mb-0 smallText text-muted">
              {{ row.item.merk }} - {{ row.item.tipe }}
            </p>
          </div>
          <div v-else>
            <p class="mb-0">{{ row.item.jenis }}</p>
            <p class="mb-0 smallText text-muted">
              {{ row.item.merk }} - {{ row.item.tipe }}
            </p>
          </div>
        </template>
        <template v-slot:cell(tanggalGadai)="row">
          <div>{{ $helper.changeDateFormat(row.item.tanggalGadai) }}</div>
          <div class="smallText text-muted">
            {{ $helper.changeDateFormatGetHour(row.item.tanggalGadai) }}
          </div>
        </template>
        <template v-slot:cell(action)="row">
          <div class="no-wrap">
            <b-link :to="`${$route.path}/${row.item.id}`">
              <b-button
                size="sm"
                class="table-button view"
                v-b-tooltip.hover
                title="Detail"
                name="gadaiViewBtn"
              >
                <i class="fa fa-info"></i>
              </b-button>
            </b-link>
          </div>
        </template>
      </b-table>

      <div class="pagination-wrapper d-flex align-items-center justify-content-between">
        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
          <b-form-select
            v-model="input.show"
            id="showItems"
            @change="onLimitChange"
            :options="options"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled />
            </template>
          </b-form-select>
          <span class="ml-2">{{ totalViewText }}</span>
        </b-input-group>
        <b-pagination
          class="mb-0"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          @input="onPageChange"
        ></b-pagination>
      </div>
    </b-card>
  </div>
</template>

<script>
import MultiSelectDropdown from "@/components/gadai/MultiSelectDropdown.vue"; // sesuaikan path

export default {
  name: "daftar-gadai",
  components: { MultiSelectDropdown },
  data() {
    return {
      initStatus: 0,
      isBusy: true,
      input: {
        show: 10,
        filterNoFaktur: null,
        filterNamaAnggota: "",
        // filterJenisBarang: null,
        filterJenisBarang: [],
        sortBy: null,
        sortDesc: null,
      },
      fields: [
        { key: "noFaktur", label: "No. Faktur" },
        { key: "namaAnggota", label: "Anggota" },
        { key: "Barang", label: "Barang" },
        { key: "nilaiPinjamanEfektif", label: "Total Pinjaman" },
        { key: "tanggalGadai", label: "Tanggal Gadai", sortable: true },
        { key: "action", label: "Aksi" },
      ],
      options: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 30, text: "30" },
        { value: 40, text: "40" },
        { value: 50, text: "50" },
      ],
      filterJenisBarang: [],
      daftarGadai: [],
      currentPage: 1,
      perPage: 10,
      rows: null,
      totalViewText: "",
      page: "",
      size: "",
      cabangId: "",
      loading: false,
      query: "",
    };
  },
  methods: {
    //----------------- Fungsi Inisialisasi -----------------

    init() {
      this.initStatus = 0;
      this.page = 0;
      this.size = this.input.show;
      this.query = this.$helper.makeQuery(this.page, this.size);
      this.cabangId = this.$helper.getCabangId();
      this.query = this.query + "&cabangId=" + this.cabangId;

      let getJenisBarang = this.$axios
        .get("/barang-jenis/all-selection/")
        .then((response) => {
          this.filterJenisBarang = response.data;
        });

      let getDaftarGadai = this.$axios
        .get("gadai/daftar-gadai-berjalan/" + this.query)
        .then((response) => {
          this.daftarGadai = response.data.data;
          this.updateTotalItem(response.data.total);
          let msg = this.$helper.getFlash();
          this.$helper.toastSucc(this, msg);
        });

      Promise.all([getJenisBarang, getDaftarGadai])
        .then(() => {
          this.initStatus = 1;
          this.toggleBusy();
        })
        .catch((error) => {
          this.initStatus = -1;
          this.toggleBusy();
        });
    },

    //----------------- Fungsi Ambil Data Daftar Gadai -----------------

    getDaftarGadai() {
      this.toggleBusy();
      this.daftarGadai = [];
      this.cabangId = this.$helper.getCabangId();

      if (this.input.filterNoFaktur != null)
        this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur;
      if (this.input.filterNamaAnggota != null)
        this.query = this.query + "&filterNamaAnggota=" + this.input.filterNamaAnggota;
      if (this.input.filterJenisBarang != null)
        this.query = this.query + "&filterJenisBarang=" + this.input.filterJenisBarang;
      if (this.input.sortBy != null)
        this.query = this.query + "&sortBy=" + this.input.sortBy;
      if (this.input.sortDesc != null)
        this.query = this.query + "&sortDesc=" + this.input.sortDesc;

      this.query += "&cabangId=" + this.cabangId;

      this.$axios
        .get("gadai/daftar-gadai-berjalan/" + this.query)
        .then((response) => {
          this.daftarGadai = response.data.data;
          this.toggleBusy();
          this.updateTotalItem(response.data.total);
          this.loading = false;
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
          this.toggleBusy();
          this.loading = false;
        });
    },

    //----------------- Fungsi Pagination, Sorting, dan loading -----------------

    onLimitChange() {
      this.size = this.input.show;
      this.perPage = this.input.show;
      this.currentPage = 1;
      this.page = 0;
      this.query = this.$helper.makeQuery(0, this.size);
      this.getDaftarGadai();
    },

    onPageChange() {
      if (this.loading == false) {
        this.page = this.currentPage - 1;
        this.query = this.$helper.makeQuery(this.page, this.size);
        this.getDaftarGadai();
      }
    },

    sortingChanged(ctx) {
      if (ctx.sortBy == "tanggalGadai") {
        this.input.sortBy = "createdAt";
        this.input.sortDesc = ctx.sortDesc;
        this.onFilter();
      } else if (ctx.sortBy != "") {
        this.input.sortBy = ctx.sortBy;
        this.input.sortDesc = ctx.sortDesc;
        this.onFilter();
      }
    },

    onReset() {
      this.input.filterJenisBarang = null;
      this.input.filterNoFaktur = null;
      this.input.filterNamaAnggota = "";
      this.currentPage = 1;
      this.page = 0;
      this.query = this.$helper.makeQuery(0, this.size);
      this.loading = true;
      this.getDaftarGadai();
    },

    onFilter() {
      this.page = 0;
      this.currentPage = 1;
      this.query = this.$helper.makeQuery(0, this.size);

      this.loading = true;
      this.getDaftarGadai();
    },

    //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

    toggleBusy() {
      if (this.isBusy == true) this.isBusy = false;
      else this.isBusy = true;
    },

    updateTotalItem(total) {
      let limit = null;
      let prevLimit = null;
      this.perPage = this.size;
      this.rows = total;
      prevLimit = this.page * this.size + 1;
      limit = this.page * this.size + this.size;
      if (limit > this.rows) limit = this.rows;
      this.totalViewText =
        "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri";
    },

    getDaftarBarangHilang() {
      this.$axios.get("gadai/barang-hilang-allowed").then((response) => {
        if (response.data.id == 0) {
          this.$helper.toastErr(
            this,
            "Tidak memiliki akses untuk melihat daftar barang hilang!"
          );
        } else {
          this.$router.push({ path: `${this.$route.path}/barang-hilang` });
        }
      });
    },
  },

  created() {
    this.init();
  },
};
</script>

<style scoped>
.daftar-gadai-filter-btn-wrapper {
  display: flex;
}

@media screen and (max-width: 600px) {
  .daftar-gadai-filter-btn-wrapper {
    margin-top: 16px;
  }
}
</style>
